<template>
    <div class="vendor-table">
        <server-tables :id="id" :headers="headers" :api="api" :store="store" :faction="faction" :taction="taction" :corder="corder">
        </server-tables>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            id: 'vendor-requests-table',
            headers: [
                { title: 'Status', data: 'status', name: 'status', className: 'status-cp'},
                { title: 'VOS Status', data: 'vos_status_text', name: 'vos_status'},
                { title: 'Job#', data: 'client_request_id', name: 'client_request_id'},
                { title: 'Job Type', data: 'job_type_id', name: 'job_type_id', width: '100px',  
                    render: function (data) {
                        switch(data){
                            case 1:
                                return 'In-Person';
                                break;
                            case 2:
                                return 'Translation';
                                break;
                            case 3:
                                return 'Telephonic';
                                break;
                            case 4:
                                return 'VRI';
                                break;
                            default:
                                return '';
                                break;
                        }
                    }
                },
                { title: 'Service Date', data: 'service_date', name: 'service_date'},
                { title: 'Service Time', data: 'service_time', name: 'service_time'},
                { title: 'Lang.', data: 'language', name: 'language'},
                { title: 'Client Name', data: 'case_name_lep', name: 'case_name_lep', 
                    render: function (data) {
                        if(! _.isEmpty(data)){
                            return (data.length > 25) ? '<span title="'+data+'">' + data.substr(0, 25) + '...</span>' : data
                        }else{
                            return ''
                        }
                        
                    }
                },
                { title: 'Location', data: 'location_name', name: 'location_name', 
                    render: function (data) {
                        if(! _.isEmpty(data)){
                            return (data.length > 50) ? '<span title="'+data+'">' + data.substr(0, 50) + '...</span>' : data
                        }else{
                            return ''
                        }
                        
                    }
                },
            ],
            api: 'view-vendor-requests',
            store: 'requests',
            faction: 'setFormData',
            taction: 'setTableData',
            corder: [ 2, "desc" ]
        }
    },
    
    computed: {
    },

    methods: {
    },

    mounted(){
        $( document ).ready(function() {
            setInterval(function(){
                if(VueStore.state.nav.newRequestSelected === false){
                    //console.log("table refesh");
                    VueStore.dispatch('datatable/resetDatatable');
                }
            }, 180000); //300000 = 5mins, 180000 = 3mins

            // keep track of table scroll
            $('div.dataTables_scrollBody').scroll(function (event) {
                var scroll = $('div.dataTables_scrollBody').scrollTop();
                // Do something
                //console.log('window scroll:'+scroll);

                sessionStorage.setItem('SCROLL-POS', scroll);
            });

            $('#is-bundled').tooltip({
                show: null,
                position:{
                    my: "left top",
                    at: "left bottom"
                }
            }); 
        });
    },

    created (){
        // get timestamp of table reload
        VueStore.dispatch('datatable/getTableTimeStamp');
    }
}
</script>


<style>
th, td { white-space: nowrap; overflow: hidden;}
div.dataTables_wrapper {
    margin: 0 auto;
}
</style>